import { Box, Typography } from "@drone-js/core";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import type { FunctionComponent } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { CardSelector } from "./CardSelector";
import { ImportOptions } from "./constants";

export const ManualMethod: FunctionComponent = () => {
    const {
        importMethodCms: { secondSelectionText, secondSelectionSubText },
    } = usePropertySelectionViewModelValue();

    return (
        <CardSelector
            id={ImportOptions.Manual}
            title={secondSelectionText}
            logo={[OneOnboardingImages.ImportMethodHome]}
            data-element-name="create-listing-manually-card"
            iconSize="58px"
            flexDirection="row"
        >
            <Box mt="24">
                <Typography variant="body-default" textColor="base.subtle">
                    {secondSelectionSubText}
                </Typography>
            </Box>
        </CardSelector>
    );
};
